import React, { useState, useEffect } from 'react';
import './App.css';
import { FiLogOut } from 'react-icons/fi';
import { Authenticator, withAuthenticator } from '@aws-amplify/ui-react';
import SearchComponent from './SearchComponent';
import LikedDancesComponent from './LikedDancesComponent';
import { Amplify } from 'aws-amplify';
import '@aws-amplify/ui-react/styles.css';
import awsconfig from './aws-exports';
import { DataStore } from 'aws-amplify/datastore';
import Footer from './basics/Footer';
import { BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import { ThemeProvider, useTheme } from './ThemeContext';
import { FaMoon, FaSun } from 'react-icons/fa'; // Import icons for the theme toggle
import { FiHome, FiSettings } from 'react-icons/fi'; 
import UserSettings from './UserSettings';
import Impressum from './basics/Impressum';
import Datenschutz from './basics/Datenschutz';


Amplify.configure(awsconfig, { ssr: false });

console.log('Amplify Config:', JSON.stringify(awsconfig, null, 2));

function AppContent() {
  const [activeTab, setActiveTab] = useState('search');
  const [isDataStoreReady, setIsDataStoreReady] = useState(false);
  const { darkMode, toggleDarkMode } = useTheme(); // Add theme hook

  useEffect(() => {
    let subscription;
    let timeoutId;
    let retryCount = 0;
    const MAX_RETRIES = 2;

    const initDataStore = async () => {
      try {
        await DataStore.stop();
        await DataStore.clear();
        await DataStore.start();
        
        clearTimeout(timeoutId);
        setIsDataStoreReady(true);
      } catch (error) {
        console.error('Error initializing DataStore:', error);
        clearTimeout(timeoutId);
      }
    };

    const retryInit = async () => {
      if (retryCount < MAX_RETRIES) {
        retryCount++;
        console.warn(`DataStore timeout - retry ${retryCount}/${MAX_RETRIES}`);
        await DataStore.stop();
        timeoutId = setTimeout(retryInit, 10000);
        initDataStore();
      } else {
        console.error('DataStore failed after max retries');
      }
    };

    timeoutId = setTimeout(retryInit, 10000);
    initDataStore();

    return () => {
      clearTimeout(timeoutId);
      if (subscription) {
        subscription.unsubscribe();
      }
      DataStore.stop();
    };
  }, []);

  return (
    <div className={`App ${darkMode ? 'dark-mode' : ''}`}>
      <Router>
        <Routes>
          <Route path="/privacy" element={<Datenschutz />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/*" element={
            <Authenticator 
          socialProviders={['google']}
          loginMechanisms={['email']}
        >
              {({ signOut }) => (
            <main>
              <div className="header-buttons">
              <button 
                onClick={() => window.location.href='/'} 
                className="home-button"
                aria-label="Go to home"
              >
               <FiHome />
              </button>
              <button 
                onClick={() => window.location.href='/settings'} 
                className="settings-button"
                aria-label="User settings"
              >
                <FiSettings />
              </button>
                <button 
                  onClick={toggleDarkMode} 
                  className="theme-toggle-button"
                  aria-label={darkMode ? "Switch to light mode" : "Switch to dark mode"}
                >
                  {darkMode ? <FaSun /> : <FaMoon />}
                </button>
                <button 
                  onClick={signOut} 
                  className="sign-out-button"
                  aria-label="Sign out"
                >
                  <FiLogOut />
                </button>
              </div>
              <Routes>
                <Route path="/" element={
                  <div className="content-wrapper">
                    {!isDataStoreReady && (
                      <div>Synchronizing data...</div>
                    )}
                    {isDataStoreReady && (
                      <>
                        <div className="tabs">
                          <button 
                            className={`tab ${activeTab === 'search' ? 'active' : ''}`}
                            onClick={() => setActiveTab('search')}
                          >
                            Search Dances
                          </button>
                          <button 
                            className={`tab ${activeTab === 'liked' ? 'active' : ''}`}
                            onClick={() => setActiveTab('liked')}
                          >
                            Liked Dances
                          </button>
                        </div>

                        <div className="tab-content">
                          {activeTab === 'search' ? (
                            <SearchComponent />
                          ) : (
                            <LikedDancesComponent />
                          )}
                        </div>
                      </>
                    )}
                  </div>
                } />
                <Route path="/settings" element={<UserSettings />} />
              </Routes>
              <Footer />
            </main>
          )}
        </Authenticator>
          } />
        </Routes>
      </Router>
    </div>
  );
}

// Modify the main App component to include ThemeProvider
function App() {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  );
}

// In your App.js, modify the SignUp FormFields component:
export default withAuthenticator(App, {
  socialProviders: ['google'],
  components: {
    SignUp: {
      FormFields() {
        const [showPrivacy, setShowPrivacy] = useState(false);

        const PrivacyDialog = () => (
          <dialog
            open={showPrivacy}
            style={{
              position: 'fixed',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              maxWidth: '90%',
              maxHeight: '90vh',
              width: '600px',
              padding: '20px',
              backgroundColor: 'var(--amplify-colors-background-secondary)',
              color: 'var(--amplify-colors-font-primary)',
              border: '1px solid var(--amplify-colors-border-primary)',
              borderRadius: '8px',
              zIndex: 1000,
              overflowY: 'auto'
            }}
          >
            <div style={{ position: 'relative' }}>
              <button
                onClick={() => setShowPrivacy(false)}
                style={{
                  position: 'absolute',
                  right: '0',
                  top: '0',
                  background: 'none',
                  border: 'none',
                  fontSize: '1.5rem',
                  cursor: 'pointer',
                  color: 'var(--amplify-colors-font-primary)'
                }}
                aria-label="Close privacy policy"
              >
                ×
              </button>
              <Datenschutz />
            </div>
          </dialog>
        );

        return (
          <>
            <Authenticator.SignUp.FormFields />
            <div style={{ marginBottom: '1rem' }}>
              <label style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                <input
                  type="checkbox"
                  name="policies"
                  value="accepted"
                  required
                  style={{ marginTop: '4px' }}
                />
                <span>
                  I agree to the{' '}
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      setShowPrivacy(true);
                    }}
                    style={{
                      color: 'var(--amplify-components-button-primary-background-color)',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      background: 'none',
                      border: 'none',
                      padding: 0,
                      font: 'inherit'
                    }}
                  >
                    Privacy Policy
                  </button>
                  {' '}and{' '}
                  <a
                    href="https://www.spotify.com/legal/end-user-agreement/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: 'var(--amplify-components-button-primary-background-color)',
                      textDecoration: 'none'
                    }}
                  >
                    Spotify Terms of Service
                  </a>
                </span>
              </label>
            </div>
            {showPrivacy && <PrivacyDialog />}
          </>
        );
      },
    },
  },
  services: {
    async validateCustomSignUp(formData) {
      if (!formData.policies) {
        return {
          policies: 'You must agree to the terms and policies to create an account.',
        };
      }
    },
  },
});
